import createImageUrlBuilder from "@sanity/image-url";
import ProvincesMaroc from "assets/ProvincesMaroc/ProvincesMaroc.json";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import AnnoncesCards from "SanityComponents/Annonces/AnnoncesCards";
import Footer from "SanityComponents/Footer/Footer";
import ThreeGuideButtons from "SanityComponents/GuideDuCredit/ThreeGuideButtons";
import LpPrixImmobilier from "SanityComponents/LandingPage/LpPrixImmobilier";
import ThreeButtons from "SanityComponents/LandingPage/ThreeButtons";
import Question from "SanityComponents/Question/Question";
import SanityHeadSeo from "../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import EstimationHeader from "../SanityComponents/CreditImmobilierComponents/EstimationHeader";
import style from "./style.module.css";
import WhatssapComponent from "SanityComponents/WhatssapComponent";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});

function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

export function Annonces(props: { data: any | null }) {
  const { t, lang } = useTranslation("LandingPage");
  const { data } = props;
  return (
    <div className={style.header}>
      {data?.content.map((item, key) => {
        if (item._type == "lpheader") {
          return (
            <EstimationHeader
              title={item.titre ? item.titre[lang] : ""}
              subtitle={item.soustitre ? item.soustitre[lang] : null}
              overlay={item.overlay_image}
              content={item.content}
              backgroundUrl={urlFor(item.background_image)
                .format("webp")
                .auto("format")
                .fit("clip")
                .auto("format")
                .toString()}
              annoncesSearchBar={
                item.SearchBarAnnonces ? item.SearchBarAnnonces : null
              }
              t={t}
              lang={lang}
            />
          );
        } else {
          return (
            <div className={style.contentContainer}>
              {item.AnnoncesCards &&
                item.AnnoncesCards?.AnnoncesCards?.length > 0 && (
                  <div className={style.annoncescardContainer}>
                    <div className={style.cardTitle}>
                      <p className={style.title}>
                        {item.AnnoncesCards?.titre[lang]}
                        {/* Comment pouvons-nous{" "}
                          <span style={{ fontWeight: "500" }}>vous aider</span> ? */}
                      </p>
                    </div>

                    <div className={style.annoncescards}>
                      {item.AnnoncesCards?.AnnoncesCards?.map((elem, index) => {
                        return (
                          <>
                            {elem && (
                              <AnnoncesCards
                                content={
                                  elem.subtitle ? elem.subtitle[lang] : ""
                                }
                                overlay={elem.overlay_image}
                                // content={elem.text[lang]}
                                backgroundUrl={urlFor(elem.mainImage)
                                  .format("webp")
                                  .auto("format")
                                  .fit("clip")
                                  .auto("format")
                                  .toString()}
                              />
                            )}
                          </>
                        );
                      })}
                    </div>
                  </div>
                )}
              {item._type == "GuideThreeButtons" && (
                <>
                  <ThreeGuideButtons
                    button1={item.button1 ? item.button1[lang] : ""}
                    link_button1={
                      item.link_button1 ? item.link_button1[lang] : ""
                    }
                    button2={item.button2 ? item.button2[lang] : ""}
                    link_button2={
                      item.link_button2 ? item.link_button2[lang] : ""
                    }
                    button3={item.button3 ? item.button3[lang] : ""}
                    link_button3={
                      item.link_button3 ? item.link_button3[lang] : ""
                    }
                    lang={lang}
                  />
                </>
              )}
              {(item._type == "WhatssapComponent") ?
                <WhatssapComponent
                  number={item?.numberPhone ? item.numberPhone : null}
                  message={item?.message ? item.message[lang] : null}
                />
              :null}
              {item._type == "ThreeButtons" && (
                <>
                  <ThreeButtons
                    btn1={item.titre_button1 ? item.titre_button1[lang] : ""}
                    // link1 = {elem.button_link1[lang]}

                    btn2={item.titre_button2[lang]}
                    // link2 = {elem.button_link2[lang]}

                    btn3={item.titre_button3[lang]}
                    // link3 = {elem.button_link3[lang]}
                    provinces={ProvincesMaroc}
                    t={t}
                  />
                </>
              )}
              {item._type == "QuestionImmobilier" && (
                <div>
                  <Question
                    title={item.titre ? item.titre[lang] : ""}
                    text={item.text ? item.text[lang] : ""}
                    buttonText={item.button_text ? item.button_text[lang] : ""}
                    image={urlFor(item.mainImage)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    button_link={item.button_link}
                  />
                </div>
              )}
              {item._type == "SanityHeadSeo" && (
                <SanityHeadSeo
                  key={key}
                  title={item.titre ? item.titre[lang] : ""}
                  ogTitle={item.titre ? item.titre[lang] : ""}
                  description={item.description ? item.description[lang] : ""}
                  ogDescription={item.description ? item.description[lang] : ""}
                  canonicalUrl={item.canonicalUrl}
                  ogTwitterImage={
                    item.mainImage
                      ? urlFor(item.mainImage)
                          .width(250)
                          .height(250)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()
                      : null
                  }
                  ogType={item.ogType}
                  ogImageUrl={
                    item.mainImage
                      ? urlFor(item.mainImage)
                          .width(250)
                          .height(250)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()
                      : null
                  }
                  structuredData={null}
                >
                  <></>
                </SanityHeadSeo>
              )}
              {item._type == "LpPrixImmobilier" && (
                <div className={style.simulez}>
                  <LpPrixImmobilier
                    title={item.titre ? item.titre[lang] : ""}
                    texte={item.texte[lang]}
                    buttonText={item.button_text ? item.button_text[lang] : ""}
                    button_link={item.button_link}
                  />
                </div>
              )}
              {item.card && (
                <>
                  {item.card?.AideCards?.length > 0 && (
                    <div className={style.annoncescardContainer}>
                      {item.card?.titre && (
                        <div className={style.cardTitle}>
                          <p>{item.card?.titre[lang]}</p>
                        </div>
                      )}

                      <div className={style.annoncescards}>
                        {item.card?.AideCards?.map((elem, index) => {
                          return (
                            <>
                              {elem && (
                                <AnnoncesCards
                                  title={elem.titre[lang]}
                                  content={elem.text ? elem.text[lang] : ""}
                                  overlay={elem.overlay_image}
                                  backgroundUrl={urlFor(elem.mainImage)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()}
                                />
                              )}
                            </>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </>
              )}
              {item._type == "SanityFooter" && (
                <>
                  <div className={style.footer}>
                    <div className={style.footerDesk}>
                      <Footer
                        propos={item.propos[lang]}
                        proposText={item.text ? item.text[lang] : ""}
                        donnee={item.donnees[lang]}
                        donneeText={item.textdonnee[lang]}
                        technologie={item.technologie[lang]}
                        technologieText={item.texttechnologies[lang]}
                        logo={urlFor(item.agenz_logo)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()}
                        facebook={urlFor(item.facebook_logo)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()}
                        instagram_logo={urlFor(item.instagram_logo)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()}
                        linked_in={urlFor(item.linkedin_logo)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()}
                        socialMediaText={item.socialMediatext}
                        copyRightText={item.permission_text}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        }
      })}
    </div>
  );
}
